import { BaseSearchController } from './base_search_controller'

export default class extends BaseSearchController {
  static targets = ['search', 'results', 'dropdown']

  initialize() {
    super.initialize()
  }

  _showResults(aData) {
    super._showResults(aData)

    this.searchTarget.focus()
  }

  _clearResults() {
    super._clearResults()
  }
}
